import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostListener,
  inject,
  OnInit,
} from '@angular/core';
import {
  NavigationEnd,
  Router,
  RouterLink,
  RouterModule,
} from '@angular/router';
import { filter } from 'rxjs';
import { AuthService } from '../../../core/auth/auth.service';
import { UserService } from '../../../core/user/user.service';
import { Dialog, DialogModule } from '@angular/cdk/dialog';
import { WorkOfArtModalComponent } from '../../modals/work-of-art-modal/work-of-art-modal.component';
import { MenuModalComponent } from '../../modals/menu-modal/menu-modal.component';
import { AccessModalComponent } from '../../modals/access-modal/access-modal.component';
import { MatIconModule } from '@angular/material/icon';
import { ProfileModalComponent } from '../../modals/profile-modal/profile-modal.component';
import { NotificationsModalComponent } from '../../modals/notifications-modal/notifications-modal.component';
import { MatBadgeModule } from '@angular/material/badge';
import { ON_DEMAND_LABEL, PARTNERS_LABEL } from '../nav-labels';
interface NavItem {
  label: string;
  path: string;
  exact?: boolean;
}

@Component({
  selector: 'app-header',
  imports: [
    RouterLink,
    NgClass,
    RouterModule,
    DialogModule,
    MatIconModule,
    MatBadgeModule,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class HeaderComponent implements OnInit {
  dialog = inject(Dialog);

  isAuthRoute: boolean = false;
  notificationCount: number = 0;
  actions = [
    {
      url: '/auth/sign-in',
      text: 'Únete',
      moviment: '/auth/sign-up',
    },
    {
      url: '/auth/sign-up',
      text: 'Inicia sesión',
      moviment: '/auth/sign-in',
    },
  ];

  action: any = {};

  user: any = null;

  navItems: NavItem[] = [
    { label: 'Inicio', path: '/home', exact: true },
    { label: 'Obras', path: '/worksofart' },
    { label: 'Artistas', path: '/artists' },
    { label: ON_DEMAND_LABEL, path: '/events' },
    { label: 'Somos', path: '/about' },
    { label: PARTNERS_LABEL, path: '/partners' },
    { label: 'Contacto', path: '/contact' },
  ];

  showUserMenu: boolean = false;
  scrolled = false;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    // cuando haces scroll más allá de 10px, activamos el estado
    this.scrolled = window.pageYOffset > 10;
    this.cdr.detectChanges();
  }
  url = '';

  constructor(
    public router: Router,
    private cdr: ChangeDetectorRef,
    public authService: AuthService,
    private userService: UserService,
  ) {
    // Constructor logic here
    // detectar rutapara asignar nombre de la acción
  }

  ngOnInit(): void {
    this.isAuthRoute = this.router.url.startsWith('/auth');
    this.action =
      this.router.url === '/auth/sign-in' ? this.actions[0] : this.actions[1];

    // this.authService.signOut();
    this.cdr.markForCheck();

    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe((e: NavigationEnd) => {
        // Si la URL empieza con /auth, true; si no, false
        this.isAuthRoute = e.urlAfterRedirects.startsWith('/auth');
        this.action =
          e.urlAfterRedirects === '/auth/sign-in'
            ? this.actions[0]
            : this.actions[1];

        this.url = e.url;

        this.cdr.markForCheck();
      });

    this.userService.user$.subscribe((user) => {
      if (user) {
        this.user = user;
        this.cdr.markForCheck();
      } else {
        this.user = null;
        this.cdr.markForCheck();
      }
    });
  }

  goToNotifications() {
    this.router.navigate(['/notifications']);
  }

  goToProfile() {
    this.router.navigate(['/profile']);
  }

  openAccessModal(): void {
    this.dialog.open(AccessModalComponent, {
      maxHeight: '92vh',
      maxWidth: '100vw',
      autoFocus: 'first-tabbable',
      ariaLabelledBy: 'access-title',
    });
  }

  toggleMobileMenu() {
    const dialogRef = this.dialog.open(MenuModalComponent, {
      maxHeight: '90%',
      maxWidth: '90vw',
      data: {
        menuItems: [
          ...this.navItems,
          { label: 'Acceder', action: 'open-access' },
          ...(this.user
            ? [
                { label: 'Perfil', path: '/profile' },
                { label: 'Cerrar sesión', path: '/auth/sign-out' },
              ]
            : []),
        ],
        isAuthRoute: this.isAuthRoute,
        user: this.user,
      },
    });
    dialogRef.closed.subscribe((result: any) => {
      if (result?.action === 'open-access') {
        this.openAccessModal();
        return;
      }
      if (result?.label === 'Cerrar sesión') {
        this.authService.signOut();
        return;
      }
      if (result?.path) {
        void this.router.navigate([result.path]);
      }
    });
    // tu lógica para desplegar menú responsivo
  }

  openProfileModal() {
    const dialogRef = this.dialog.open(ProfileModalComponent, {
      data: {
        title: 'Perfil',
        description: 'Aquí puedes ver y editar tu perfil.',
        user: this.user,
      },
    });
    dialogRef.closed.subscribe();
  }

  openNotifications() {
    this.dialog.open(NotificationsModalComponent, {
      width: '500px',
      data: { notifications: [] },
      autoFocus: false,
    });
  }
}
